/**
 * Canonical list of backflow assembly sizes, smallest → largest.
 *
 * This is the single source of truth for size dropdowns across the app
 * (office Add/Edit Device modals AND the field workflow). Size selection
 * must NEVER be limited to "sizes already in the catalog" for a given
 * assembly type — any device can in principle exist at any size, so the
 * full list is always offered. (The device catalog/cascade is still used
 * to narrow manufacturer/model, just not size.)
 */
export const SIZE_OPTIONS = [
    '1/2"',
    '3/4"',
    '1"',
    '1-1/4"',
    '1-1/2"',
    '2"',
    '2-1/2"',
    '3"',
    '4"',
    '6"',
    '8"',
    '10"',
    '12"',
] as const;

/**
 * Merge the canonical sizes with any extra sizes that came back from the
 * device cascade (e.g. an unusual catalog size like 16"), preserving the
 * canonical order first and appending unknowns at the end. Always returns
 * the full canonical list at minimum.
 */
export function mergeSizeOptions(extra: readonly string[] = []): string[] {
    const out: string[] = [...SIZE_OPTIONS];
    for (const s of extra) {
        const v = (s ?? "").trim();
        if (v && !out.includes(v)) out.push(v);
    }
    return out;
}
